import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import { loginUser } from '../../utils/api';
import News from '../shorts/News';
import Tests from '../shorts/Tests';

import '../../assets/css/login.css';

const Login = () => {
    const { login } = useAuth();
    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = { email, password };

        try {
            const response = await loginUser(data);
            login(response.user, response.token);
            navigate('/');
            window.location.reload();
        } catch (err) {
            setError('Invalid email or password');
        }
    };

    return (
        <>
            <main>
                <div className='wrapper'>
                    <div className='rows'>
                        <div className='row-login'>
                            <div className='category'>Anmeldung</div>
                            <div className='login-form'>
                                <form onSubmit={handleSubmit}>
                                    <div className='input-group'>
                                        <label for='email'>E-Mail</label>
                                        <input
                                            id='email'
                                            type="email"
                                            placeholder="Email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                        />
                                    </div>
                                    <div className='input-group'>
                                        <label for='password'>Passwort</label>
                                        <input
                                            id='password'
                                            type="password"
                                            placeholder="Password"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                        />
                                    </div>
                                    <button type="submit">Login</button>
                                </form>
                                <div className='register-box'>
                                    <div className='headline'>
                                        Neu bei NGCTV?
                                    </div>
                                    <div className='subline'>
                                        Registriere dich jetzt kostenlos
                                    </div>
                                    <Link to="/register" className="btn-register" viewTransition>Jetzt kostenlos registrieren</Link>
                                </div>
                                {error && <div>{error}</div>}
                            </div>
                        </div>
                        <div className='row'>
                            <Tests />
                            <News />
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default Login;
